import React, { useState } from 'react';
import styled from 'styled-components';
import emailjs from 'emailjs-com';
import SuccessMessage from './SuccessMessage';

const FormStyle = styled.form`
  width: 100%;
  .form-group {
    width: 100%;
    margin-bottom: 2rem;
  }
  label {
    font-size: 1.8rem;
  }
  input,
  textarea {
    width: 100%;
    font-size: 2rem;
    padding: 1.2rem;
    color: var(--gray-1);
    background-color: var(--deep-dark);
    outline: none;
    border: none;
    border-radius: 8px;
    margin-top: 1rem;
  }
  textarea {
    min-height: 250px;
    resize: vertical;
  }
  .error-message {
    color: red;
    font-size: 1.5rem;
    margin-top: 0.5rem;
  }
  button[type='submit'] {
    background-color: var(--gray-1);
    color: var(--white);
    font-size: 2rem;
    display: inline-block;
    outline: none;
    border: none;
    padding: 1rem 4rem;
    border-radius: 8px;
    cursor: pointer;
  }
`;

export default function ContactForm() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const [errors, setErrors] = useState({ name: '', email: '', message: '' });

  const validateFields = () => {
    const newErrors = { name: '', email: '', message: '' };
    if (!name.trim()) newErrors.name = "Field can't be empty";
    if (!email.trim()) newErrors.email = "Field can't be empty";
    if (!message.trim()) newErrors.message = "Field can't be empty";
    setErrors(newErrors);
    return !newErrors.name && !newErrors.email && !newErrors.message;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateFields()) return;

    const templateParams = {
      name,
      email,
      message,
    };

    emailjs
      .send('service_ctknmns', 'template_mgo8ufp', templateParams, 'mtFBdmu_tmmaNCVbZ')
      .then(
        (result) => {
          console.log(result.text);
          setSubmitted(true);
          setName('');
          setEmail('');
          setMessage('');
          setErrors({ name: '', email: '', message: '' });
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <>
      <FormStyle onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="name">
            Your Name
            <input
              type="text"
              id="name"
              name="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            {errors.name && <p className="error-message">{errors.name}</p>}
          </label>
        </div>
        <div className="form-group">
          <label htmlFor="email">
            Your Email
            <input
              type="email"
              id="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            {errors.email && <p className="error-message">{errors.email}</p>}
          </label>
        </div>
        <div className="form-group">
          <label htmlFor="message">
            Your message
            <textarea
              id="message"
              name="message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
            {errors.message && <p className="error-message">{errors.message}</p>}
          </label>
        </div>
        <button type="submit">Send</button>
      </FormStyle>
      <SuccessMessage
        isOpen={submitted}
        onClose={() => setSubmitted(false)}
      />
    </>
  );
}
